<template>
    <section
        class="bg-black-700 full-width relative phone:h-screen tabletLandscape:h-screen flex flex-col">
        <!--Image Background-->
        <background-image
            :src="sectionAboutUs.src"
            :srcset="sectionAboutUs.imgSrcSet" />

        <!--Content Layout in a Container-->
        <div
            class="container flex phone:flex-col phone:justify-end flex-grow z-10 pt-8 tablet:pt-16 pb-16 tablet:items-end">
            <!--Layout Spacer -- Matches Aside Text Component sizing/spacing-->
            <div class="hidden tablet:flex w-1/4 max-w-xxs mr-10 desktop:mr-32"></div>

            <!--Content Block  -->
            <div class="section-text-with-button flex flex-col items-start">
                <!--Content Text Component-->
                <content-text>
                    <template #title-text>
                        <h2
                            class="font-light"
                            v-html="sectionAboutUs.title"></h2>
                    </template>
                    <template #content-text>
                        <div
                            class="font-regular mb-6"
                            v-html="sectionAboutUs.content">
                        </div>
                    </template>
                </content-text>

                <!-- CTA button -->
                <!--<tis-button class="btn-flat block text-sm">-->
                <!--{{sectionAboutUs.buttonText}}-->
                <!--<svg-icon icon="arrow-horizontal" class="w-6 h-6 inline-block ml-2"/>-->
                <!--</tis-button>-->
            </div>
        </div>
    </section>
</template>

<script>
import ContentText from '@web/components/ContentText';
import BackgroundImage from '@web/components/BackgroundImage';
import TisButton from '@whisper/components/buttons/TisButton';
import SvgIcon from '@whisper/components/icons/SvgIcon';

export default {
  components: {
    TisButton,
    SvgIcon,
    ContentText,
    BackgroundImage,
  },
  props: {
    sectionAboutUs: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">

</style>
